module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.9950e9ec.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Source_Sans_Pro/SourceSansPro-BoldItalic.ttf
// module id = 79
// module chunks = 0